import { createFileRoute } from '@tanstack/react-router';
import { useRegistrationGuard } from '@/hooks/use-registration-guard';
import { STEPS } from '@/features/cleaner/apply-cleaner/constant';
import { BackgroundCheckStep } from '@/features/cleaner/apply-cleaner/steps/background-check-step';

function BackgroundCheckRoute() {
  useRegistrationGuard({
    requiredStep: STEPS.BACKGROUND_CHECK,
    requireAuth: true,
    redirectTo: '/apply-cleaner/personal-info',
  });

  return <BackgroundCheckStep />;
}

export const Route = createFileRoute(
  '/(cleaner)/apply-cleaner/background-check'
)({
  component: BackgroundCheckRoute,
});
